import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";
import Text from "../../components/Text";

const points1 = [
    { icon: "", text: "1. Teacher writes a note in the student's record." },
    { icon: "", text: "2. AI reads the note and matches it with recent marks and attendance." },
    { icon: "", text: "3. AI creates a message and suggests helpful steps for the parent." },
];

const data = [  {
    cIcon: <span className="font-bold text-5xl">1</span>,
    cIconColor: "text-[#4949DE]",
    title: "Study student data",
    description: "Our AI reads teacher remarks, homework, attendance, marks and behaviour notes."
  },{
    cIcon: <span className="font-bold text-5xl">2</span>,
    cIconColor: "text-[#4949DE]",
    title: "Create a caring message",
    description: "It writes a clear, kind message that explains what happened, why, and next steps."
  },{
    cIcon: <span className="font-bold text-5xl">3</span>,
    cIconColor: "text-[#4949DE]",
    title: "Send via WhatsApp",
    description: "Message reaches the parent automatically. Parents can reply and interact with the AI."
  },{
    title: "Example Teacher Flow",
    description: <div className="space-y-3">
        {points1.map((section, index) => (
            <div key={"fasdasdasd" + index} className="flex items-center gap-3">
                <Text label={section.text} cName="text-xs text-[#4D4D4D] text-pretty font-medium" />
            </div>
        ))}
    </div>
},{
    title: "Example Student Chat",
    description: "Hi Arav, I noticed you're finding Maths hard this week. Let's try a few practice questions together. Ready?"
}];


export default function HowItWorks() {

    return (
        <Box
            badge={"Process"}
            title={"How It Works"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    {/* <div className="grid grid-cols-3 mt-8 gap-6"> */}
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {data.slice(0, 3).map((member, index) => <MarktingCard key={"HowItWorks" + index} member={member} />)}
                    </div>
                </div>
            }
            rightBlock={data.slice(3).map((member, index) => <MarktingCard key={"HowItWorks" + index} member={member} />)}
        />
    );
}